export default "__VITE_ASSET__CKjDp43p__$_?url__"